export async function getRates() {
	try {
		const response = await fetch('https://foreign.foreignpay.ru/rates', {
			method: 'GET',
			headers: {
				'Content-Type': 'application/json'
			}
		});

		if (!response.ok) {
			throw new Error(`Ошибка: ${response.status}`);
		}

		const data = await response.json();
		return data;
	} catch (error) {
		console.error('Ошибка при получении курсов:', error.message);
	}
}